import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck, Check, Banknote } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <Section data-id="element-78">
      {/* Layer 11: Guarantee */}
      <motion.div whileInView={{
      boxShadow: '0 0 0 4px rgba(45, 80, 22, 0.1)'
    }} className="border-4 border-[#2D5016] bg-white rounded-2xl p-6 md:p-8 text-center relative mt-6" data-id="element-79">
        <motion.div initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} transition={{
        type: 'spring',
        bounce: 0.5
      }} className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-[#FDF8F0] p-4 rounded-full border-4 border-[#2D5016]" data-id="element-80">
          <ShieldCheck className="w-16 h-16 text-[#2D5016]" data-id="element-81" />
        </motion.div>

        <h2 className="text-2xl md:text-3xl font-extrabold text-[#2D5016] mt-8 mb-3" data-id="element-82">
          🛡️ GARANTÍA HONOR 30 DÍAS
        </h2>

        <div className="flex flex-wrap justify-center gap-3 mb-5" data-id="element-83">
          {['Sin preguntas', 'Sin trámites', 'Sin condiciones'].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3 + i * 0.1
        }} className="flex items-center gap-1 text-[#2C1810] font-bold bg-green-50 px-3 py-1 rounded-full" data-id="element-84">
                <Check className="w-4 h-4 text-[#2D5016]" data-id="element-85" /> {item}
              </motion.div>)}
        </div>

        <div className="prose prose-lg mx-auto text-[#2C1810]/80 mb-5" data-id="element-86">
          <p data-id="element-87">
            Compra hoy. Aplica el protocolo 3 semanas con consistencia. Si no
            ves al menos 30% de mejora en tu dolor principal...
          </p>
          <p className="font-bold text-[#C1440E] text-xl" data-id="element-88">
            Te devolvemos cada peso. Completo. Inmediato.
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm md:text-base font-medium text-[#2D5016] bg-[#2D5016]/10 py-3 px-6 rounded-full inline-flex" data-id="element-89">
          <Banknote className="w-5 h-5" data-id="element-90" />
          El riesgo es 100% nuestro. El alivio es 100% tuyo.
        </div>
      </motion.div>
    </Section>;
}